import { Col, DatePicker, Row, Tabs, message } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Card, Form, Input } from "antd";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Select } from "antd";
import {
  addDocument,
  fetchOneDocument,
  updateDocument,
} from "redux/features/document";
import { MyEditor } from "../../../components/Editor";
import DocumentUploader from "components/shared-components/DocumentUploader";
import moment from "moment";

const selectStyle = {
  width: "100%",
  backgroundColor: "white",
};

const rules = [
  {
    required: true,
    message: "Wajib Diisi!",
  },
];

export const ADD_DOCUMENT = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const location = useLocation();

  const [idBody, setIdBody] = useState("");
  const [enBody, setEnBody] = useState("");
  const [subcategories, setSubcategories] = useState();
  const [tags, setTags] = useState();
  const [imgUrlDisplay, setImgUrlDisplay] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [dataCategoryOption, setDataCategoryOption] = useState([]);

  const [documentData, setDocumentData] = useState({
    url: "",
    type: "",
    filename: "",
    original_name: "",
  });

  const onFinish = (values) => {
    values.url = documentData.url;
    values.type = documentData.type;
    values.filename = documentData.filename;
    console.log("values :", values);
    if (location?.state?.id) {
      updateData(values);
    } else {
      createData(values);
    }
  };

  const createData = async (values) => {
    console.log("create data :", values);
    try {
      await dispatch(
        addDocument({
          ...values,
        })
      ).unwrap();
      history.push("/app/document");
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const updateData = async (values) => {
    try {
      await dispatch(
        updateDocument({
          ...values,
          id: location?.state?.id,
        })
      ).unwrap();
      history.push("/app/document");
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getDataById = async (id) => {
    try {
      const data = await dispatch(fetchOneDocument(id)).unwrap();
      console.log("Fetched Data:", data.data);
      form.setFieldsValue({
        ...data.data,
        document_category: data.data.document_category?.name,
      });

      const category = dataCategoryOption.find(
        (item) => item.id === data.data.document_category?.id
      );

      setSelectedCategory(category);

      setDocumentData({
        url: data.data.url || "",
        type: data.data.type || "",
        filename: data.data.filename || "",
        original_name: data.data.original_name || "",
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleDocumentUpload = (info) => {
    if (info.file.status === "uploading") {
      // setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      const { secure_url, type, filename } = info.file.response.data;
      setDocumentData({
        url: secure_url,
        type: type,
        filename: filename,
      });
    }
  };

  const { Option } = Select;

  const fetchDocumentCategories = async () => {
    try {
      const response = await fetch(
        "https://api.banyuasinkab.info/api/v1/document-category"
      );
      const result = await response.json();
      console.log("API Response:", result);
      if (Array.isArray(result.data)) {
        setDataCategoryOption(result.data);
      } else {
        message.error("Fail get the data.");
      }
    } catch (error) {
      console.error("Error fetching document categories:", error);
      message.error("Terjadi kesalahan saat mengambil data kategori.");
    }
  };

  //   const dataCategoryOption = [
  //     {
  //       id: 1,
  //       name: "Surat Keputusan",
  //     },
  //     {
  //       id: 2,
  //       name: "Umum",
  //     },
  //   ];

  useEffect(() => {
    const fetchData = async () => {
      await fetchDocumentCategories();
      if (location?.state?.id) {
        getDataById(location?.state?.id);
      }
    };

    fetchData();
  }, []);
  console.log("Current documentData:", documentData);
  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Tambah/Update Dokumen</h2>
          <p>Isi data dokumen.</p>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24} gap={3}>
          <Card>
            <Form
              name="basic"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item label="Nama Dokumen" name="name">
                <Input />
              </Form.Item>

              <Form.Item
                label="Nama Kategori"
                name="document_category"
                rules={[{ required: true, message: "Pilih nama kategori" }]}
              >
                <Select
                  placeholder="Pilih Kategori"
                  onChange={(value) => {
                    const category = dataCategoryOption.find(
                      (m) => m.name === value
                    );
                    setSelectedCategory(category);
                  }}
                >
                  {dataCategoryOption.map((item) => (
                    <Option key={item.id} value={item.name}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              {/* <Form.Item>
                <MyEditor
                  data={idBody}
                  setState={setIdBody}
                  defaultValue="Deskripsi"
                />
              </Form.Item> */}

              <Form.Item label="Dokumen" name="document">
                <DocumentUploader
                  documentData={documentData}
                  onChange={handleDocumentUpload}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
          {/* <img src={imgUrlDisplay} style={{ width: "100%" }}></img>
          <br></br>
          <h3>Ubah Foto Profil</h3> */}
        </Col>
      </Row>
    </>
  );
};

export default ADD_DOCUMENT;
